import { useContext } from 'react';
import { LanguageContext, type LanguageContextValue } from './context';
import type { MessageKey } from './messages';

export function useLanguage(): LanguageContextValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
}

export function useT(): (key: MessageKey) => string {
  return useLanguage().t;
}
